import { Component, OnInit, Renderer2, RendererFactory2, ViewChild, ViewContainerRef } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridOptions, GridReadyEvent, StatusPanelDef } from 'ag-grid-community';
import { ConfirmationService } from 'primeng/api';
import { ApiService } from 'src/app/services/api.service';
import { ResetService } from 'src/app/services/reset.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ManageCropModalHeaderComponent } from 'src/app/shared/cropManageHeader';
import { EvaluationZone } from 'src/app/models/evaluationZone';

@Component({
  selector: 'app-manageevaluationzone',
  templateUrl: './manageevaluationzone.component.html',
  styleUrl: './manageevaluationzone.component.scss'
})
export class ManageEvaluationZoneComponent implements OnInit {
  rowData : any[] =[];
  evaluationZones: EvaluationZone[] = [];
  idList: string[] = [];
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: { buttons: ["clear"] },
    resizable: true,
  };
  public columnDefs: ColDef[] = [
    { field: 'Id', headerName: 'Id', minWidth: 10, hide: true},  
    { field: 'Code', headerName: 'Code', maxWidth: 100},   
    { field: 'Description', headerName: 'Description',minWidth: 450},
    { field: 'CropName', headerName: 'Crop Name', maxWidth: 130},   
    { field: 'IsActive', headerName: 'Active In PCM', cellEditor: 'agCheckboxCellEditor', editable: true, maxWidth: 140}
  ];
  public statusBar: {
    statusPanels: StatusPanelDef[];
  } = {
    statusPanels: [
      { statusPanel: 'agTotalRowCountComponent', align: 'left' },
      { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left',  },
      { statusPanel: 'agFilteredRowCountComponent', align : 'left' },
      { statusPanel: 'agSelectedRowCountComponent', align : 'left' }     
    ],
  };
  gridOptions : GridOptions = {
    context: {
      componentParent: this,
    },
    singleClickEdit: true,
    tooltipShowDelay: 100,    
    sideBar: { toolPanels: [{
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivotMode: true,
      },
    },
    'filters'] },    
    // onGridPreDestroyed: this.onGridPreDestroyed
  }
  gridApi: any;
  renderer: Renderer2;

  get allowReset() : boolean {
    const managedRadEvaluationZones = this.rowData.map(ele => {return {Code: ele.Code, Description: ele.Description, IsActive: ele.IsActive, CropName : ele.CropName}}).sort((a: any , b: any) => a.Code.localeCompare(b.Code));
    const allRadEvaluationZones = this.evaluationZones?.map(ele => {return {Code :ele.Code, Description: ele.Description, IsActive: ele.IsActive, CropName : ele.CropName}}).sort((a: any , b: any) => a.Code.localeCompare(b.Code));
    return JSON.stringify(managedRadEvaluationZones) == JSON.stringify(allRadEvaluationZones);
  }

  constructor(public loader: LoadingService, private apiService : ApiService, private resetService: ResetService,  private confirmationService : ConfirmationService,
    private readonly rendererFactory: RendererFactory2,
    private viewContainerRef: ViewContainerRef) {
      this.loader.setMessage('Loading...');
      this.renderer = rendererFactory.createRenderer(null,null);    
  }
  
  ngOnInit(): void {
    this.apiService.getRADData("EvaluationZones?$filter=Status/Name eq 'Active'&$expand=Crop&$select=Id,Code,Description", false).subscribe((result : any) => {
      result.value.forEach((evaluationZone: any) => {  evaluationZone.CropName = evaluationZone.Crop.Name, evaluationZone.Code = evaluationZone.Code.toUpperCase(), evaluationZone.Description = evaluationZone.Description ?? "", evaluationZone.IsActive = true });
      this.evaluationZones = result.value.sort((a: any , b: any) => a.CropName.localeCompare(b.CropName) || a.Code.localeCompare(b.Code));       
      this.apiService.getOData('EvaluationZonePreferences').subscribe((result : any) => {
        if(result && result.value.length > 0) {
          result.value.forEach((ele : any) => {
            const evaluationZone = this.evaluationZones.find(e => e.Code == ele.code && e.CropName == ele.cropName);
            if(evaluationZone) {
              evaluationZone.IsActive = ele.isActive;
            }
          })
        } else {
          this.evaluationZones.forEach(ele => {ele.IsActive = true;});
        }
        this.rowData = JSON.parse(JSON.stringify(this.evaluationZones));  
        this.setScreenData();         
      });      
    });  
  }

  setScreenData() {
    setTimeout(() => {
      const componentRef = this.viewContainerRef.createComponent(ManageCropModalHeaderComponent);
      componentRef.instance.incomingData = Object.create(this);
      let titleSpan = document.getElementsByClassName('p-dialog-header-icons')[0];
      this.renderer.insertBefore(titleSpan, componentRef.location.nativeElement,titleSpan.childNodes[0]);
    },300);
  }

  // onCellEditingStarted(event: CellEditingStartedEvent) {
  //   if(event.data.Name === StaticFields.precodePreference.crop && event.value == true) {
  //     this.confirmationService.confirm({
  //       header: 'Confirmation',
  //       icon: 'pi pi-exclamation-triangle',
  //       message: 'Are you sure you want to make the crop inactive, it is saved as default preference ?',
  //       accept: () => {           
  //       },
  //       reject: () => {
  //         event.data.isActive = true;
  //         this.gridApi.redrawRows()
  //       }        
  //     })
  //   }
  // }
  
  onGridReady($event: GridReadyEvent<any>) {
    this.gridApi = $event.api;
  }
  
  submitData() {
    this.apiService.putData( "SubmitEvaluationZonePreference", this.rowData).subscribe((result : any) => {
        this.evaluationZones = JSON.parse(JSON.stringify(this.rowData));    
        this.rowData.forEach((ele : any) => {      
        const program = this.evaluationZones.find(e => e.CropName == ele.cropName && e.Code == ele.code);
        if (program) {
           program.IsActive = ele.isActive;     
        }
      });
      this.gridApi.redrawRows();   
      this.resetService.resetDataCommunicate({Type: ResetService.EvaluationZones});     
    });
  }

  reset() {
    this.confirmationService.confirm({
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      message: 'Are you sure you want to reset? Any unsaved changes will be lost',
      accept: () => {
        this.rowData = JSON.parse(JSON.stringify(this.evaluationZones));
      }      
    })
  }
}